import React from 'react';
import UtilityHeader from '@common/components/app-layout/utility-header/utility-header';
import UtilityBar from './utility-bar';

const AwareUtilityHeader = ({ children, ...props }) => {
  return (
    <UtilityHeader UtilityBar={UtilityBar} {...props}>
      {children}
    </UtilityHeader>
  );
};

export default AwareUtilityHeader;
